import styled from 'styled-components';
const stubLeft = '/wp-content/themes/wbstl/images/hero-cta-stub-left.svg';
const stubRight = '/wp-content/themes/wbstl/images/hero-cta-stub-right.svg';

export const Wrapper = styled.div`
  top: ${props => props.isModal ? '5%' : '0'};
  position: ${props => props.isModal ? 'fixed' : 'relative'};
  left: ${props => props.isModal ? '3%' : '0'};
  right: ${props => props.isModal ? '3%' : '0'};
  bottom: ${props => props.isModal ? '5%' : '0'};
  margin: ${props => props.isModal ? 'auto' : '30px auto'};
  width: ${props => props.isModal ? '90%' : '100%'};
  overflow-y: auto;
  transition: opacity .4s ease-in-out;
  opacity: 1;
  z-index: 99998;
  max-height: 650px!important;
  min-height: 400px;
  box-shadow: none!important;
  border-radius: 0;
  display: block;
  @media (min-width: 500px) {
    padding: ${props => props.isModal ? '20px 40px' : '20px 0'};
  }
  @media (min-width: 960px) {
    width: ${props => props.isModal ? '80%' : '100%'};
  }
  &.collapsible-enter-done {
    border-top: 1px solid #ccc;
    margin-top: 10px;
  }
`;
export const CloseButton = styled.div`
  position: absolute;
  top: -8px;
  right: 10px;
  font-size: 36px;
  color: #083861;
  cursor: pointer;
  transition: color .4s ease-in-out;
  z-index: 1000;

  @media (min-width: 500px) {
    top: 10px;
    right: 20px;
  }

  span:before {
    line-height: 36px;
    content: '\f057';
    font-family: "Font Awesome 5 Free";
    font-style: normal;
    font-weight: normal;
    speak: none;
    display: inline-block;
    text-decoration: inherit;
    width: 1em;
    height: 1em;
    font-size: 1em;
    text-align: center;
    -webkit-font-smoothing: antialiased;
    font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    padding-right: 3px;

    @media (max-width: 499px) {
      font-size: 32px !important;
    }
  }
`;
export const Container = styled.div`
  @media (min-width: 900px) {
    display: flex;
    margin-top: 20px;
    justify-content: space-between;
  }
`;
export const AnimContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Left = styled.div`
  @media (min-width: 900px) {
    background: #fff;
    width: 50%;
    padding: 20px;
  }
`;
export const Right = styled.div`
  @media (min-width: 900px) {
    width: 50%;
  }
`;
export const Legend = styled.div`
  display: flex;
  margin-top: 10px;
  justify-content: center;
  align-items: center;
  font-family: 'Montserrat',sans-serif;
  font-weight: 400;
`;
export const Color = styled.div`
  margin-right: 10px;
  font-family: 'Montserrat',sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 32px;

  @media (min-width: 400px) {
    font-size: 14px;
  }
  @media (min-width: 500px) {
    font-size: 16px;
  }
  :before {
    content: '';
    height: 20px;
    width: 20px;
    float: left;
    margin-right: 8px;
    margin-top: 2px
  }
  &.available:before {
    background-color: #083861;
  }
  &.soldOut:before {
    background-color: #ccc;
  }
  &.selected:before {
    background-color: #8bd0e4;
  }
`;
export const EventColor = styled.div`
  display: flex;
  margin-right: 10px;
  font-family: 'Montserrat',sans-serif;
  font-weight: 400;
  font-size: 12px;

  @media (min-width: 400px) {
    font-size: 14px;
  }
  @media (min-width: 500px) {
    font-size: 16px;
  }

  &.event0:before {
    background: #ff0000;
  }
  &.event1:before {
    background: #21693E;
  }
  &.event2:before {
    background: #5597E8;
  }
  &.event3:before {
    background: #5dcdce;
  }
  &.event4:before {
    background: #c455e8;
  }
  &.event5:before {
    background: #7b61ff;
  }
  :before {
    content: '';
    width: 14px;
    height: 14px;
    border-radius: 14px;
    border: 1px solid #fff;
    margin-right: 8px;
    margin-top: 4px;
  }
  &.large:before {
    width: 18px;
    height: 18px;
    border-radius: 18px;
  }
`;
export const DateTimeWrapper = styled.div`
  width: 100%;
  background: #fff;
  padding: 20px;
  border-radius: 4px;

  @media (min-width: 900px) {
    width: calc(100% - 25px);
    padding: ${props => props.showSelections ? '20px' : '0'};
  }
`;
export const CalendarWrapper = styled.div`
  background: #fff;
  border-radius: 4px;
  margin-bottom: 10px;

  @media (min-width: 768px) {
    padding: 8px;
  }
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  .close {
    top: -40px;
    right: -30px;
    font-size: 21px;
    color: #999;
  }
`;
export const MonthWrapper = styled.div`
  width: 100%;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;
export const Day = styled.div`
  width: 14.285714285714286%;
  background-color: #ccc;
  font-size: 12px;
  text-align: center;
  color: #6f6f6f;
  line-height: 60px;
  font-family: 'Montserrat',sans-serif;
  position: relative;

  &.large {
    font-size: 16px;
  }
  &.avail-day {
    color: #fff;
    cursor: pointer;
    background-color: #083861;
    transition: all .4s;
    font-weight: 700;
    position: relative;

    span {
      display: block;
      border: 1px solid #fff;
      width: 100%;
      height: 100%;
      line-height: 60px;
    }
  }
  &.selected-day {
    color: #fff;
    cursor: pointer;
    background-color: #8bd0e4;
  }
  &.current-day {
    position: relative;
    span {
      display: block;
      border: 4px solid #fff;
      width: 100%;
      height: 100%;
      line-height: 50px;
      position: absolute;
    }
  }
`;
export const EventDot = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 14px;
  border: 1px solid #fff;
  position: absolute;
  top: 4px;
  right: 4px;

  &.event0 {
    background: #ff0000;
  }
  &.event1 {
    background: #21693E;
  }
  &.event2 {
    background: #5597E8;
  }
  &.event3 {
    background: #5dcdce;
  }
  &.event4 {
    background: #c455e8;
  }
  &.event5 {
    background: #7b61ff;
  }
`;
export const BlankSpot = styled.div`
  width: 22px;
  height: 18px;
  margin: 0 0 0 10%;
  display: inline-block;
`;
export const AvailNumber = styled.div`
  background-color: #F6BD49;
  color: #fff;
  margin: 0 0 4px 5%;
  position: relative;
  padding: 0 2px;
  display: inline-block;
  min-width: 23px;
  line-height: 19px;
  height: 18px;
  vertical-align: middle;
  font-size: .75em;

  @media (min-width: 500px) {
    min-width: 27px;
  }
  @media (min-width: 1200px) {
    min-width: 34px;
    font-size: 1em;
  }
  &::before, &::after {
    content: "";
    position: absolute;
    display: block;
    top: 0;
    bottom: 0;
    width: 7px;
    background-size: auto 100%;
    background-position: 50%;
    background-repeat: no-repeat;
  }
  &::before {
    left: -8px;
    background-image: url(${stubLeft});
  }
  &::after {
    right: -8px;
    background-image: url(${stubRight});
  }
  &.icon {
    margin: 0 15px 5px 0;
    height: 18px;
  }
`;
export const WeekTimes = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    overflow: hidden;
    max-height: 0px;
    transition: max-height .05s ease-in-out;

    &.active {
      max-height: 1000px;
      padding: 0 0 2px 0;
      background: #f0f0f0;
    }
    button {
      margin: 2px;
      width: calc(50% - 4px);
      padding: 0;
      font-size: .85em;

      @media (min-width: 500px) {
        font-size: 1em;
      }
      &.selected {
        background-color: #8bd0e4;
      }
      &:active {
        background-color: #083861;
        color: #fff;
      }
    }
`;
export const Week = styled.div`
    display: flex;
    width: 100%;
    background: #f0f0f0;
`;
export const WeekDays = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;
export const DayName = styled.div`
    text-transform: uppercase;
    text-align: center;
    font-size: 12px;
    font-family: 'Montserrat', sans-serif;
    width: 14.285714285714286%;
`;
export const BlankDay = styled.div`
    width: 14.285714285714286%;
    height: 50px;
`;
export const MonthName = styled.div`
    color: #000;
    cursor: pointer;
    width: 80%;
    text-align: center;

    form {
      display: inline-block;
    }
`;
export const CustomSelect = styled.div`
  display: inline-block;
  background: #fff;
  position: relative;
  z-index: 20;

  &.active .select_options {
    display: block;
    animation: fadeInDown 500ms;
    background: #fff;
    box-shadow: 0 1px 5px rgba(0,0,0,0.3);
    border-radius: 0 0 5px 5px;
    padding: 10px 0;
  }
  &.active .select_placeholder {
    background: #fff;
    z-index: 5;
    border-radius: 5px 5px 0 0;
    box-shadow: 0 -1px 8px -1px rgba(0,0,0,0.3);
  }
`;
export const SelectPlaceholder = styled.div`
  font: normal normal 500 21px/1.2em Montserrat,Arial,sans-serif;
  text-transform: uppercase;
  padding: 0.2em 0.5em;
  position: relative;

  &::after {
    display: inline-block;
    font-weight: 600;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    font-family: "Font Awesome 5 Free";
    content: "\f107";
    margin-left: 5px;
    font-size: 18px;
  }
`;
export const SelectOptions = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  display: none;
  list-style-type: none;
  text-align: left;
  font-size: 1em;
  width: 100%;
  box-sizing: border-box;
  animation: fadeInDown 500ms;
  background: #fff;
  -moz-box-shadow: 0 1px 15px rgba(0,0,0,0.3);
  -webkit-box-shadow: 0 1px 15px rgba(0,0,0,0.3);
  box-shadow: 0 1px 5px rgba(0,0,0,0.3);
  border-radius: 0 0 5px 5px;
  padding: 10px 0;
`;
export const SelectOption = styled.div`
  display: block;
  padding: 5px 0;
  text-align: center;
  user-select: none;
  width: 100%;
  line-height: 1em;
  font-size: 21px;
  font-family: Montserrat,Arial,sans-serif;
  text-transform: uppercase;
  vertical-align: middle;
  background-color: ${props => props.selected ? '#8cd0e5' : 'transparent'};

  &:hover {
    background-color: rgba(146,208,229,0.3);
  }
`;
export const DateField = styled.select`
    display: none;
    color: #000;
    background: none;
    border: 0;
    font-size: 21px;
    text-transform: uppercase;
    font-family: 'Montserrat',sans-serif !important;
    vertical-align: middle;
    text-align: right;
    outline: 0;
    cursor: pointer;
    padding: 10px 20px 10px 15px !important;
    -moz-appearance:none;
    -webkit-appearance: none;
    appearance:none;
    position: relative;
    background-image: ${props => props.numItems > 1 ? "url('/wp-content/themes/wbstl/images/expand_arrow.png')" : 'none'};
    background-repeat: no-repeat;
    background-size: 15px;
    background-position: right center;
    float: left;

    &:first-child {
      width: 50%;
      direction: rtl;
      padding-left: 0 !important;
    }
    &::-ms-expand {
      display: none;
    }
`;
export const MonthArrow = styled.div`
    display: inline-block;
    cursor: pointer;
    padding: 0 10px;
    width: 10%;

    .fa {
      width: auto;
    }
    &.next {
      text-align: right;
    }
    &.disabled {
      cursor: not-allowed;
      color: #ccc;
    }
`;
export const TimesCols = styled.div`
  display: flex;
`;
export const TimesCol = styled.div`
  width: 25%;
`;
export const ListOfTimes = styled.div`
  padding: 33px 0 0 0;
  width: 25%;
`;
export const TimesWrapper = styled.div`
  @media (min-width: 900px) {
    max-height: 290px;
    overflow-y: auto;
  }
`;
export const Title = styled.h3`
  font-size: 18px;
  line-height: 1.2;

  &.date {
    font-size: 18px;
    letter-spacing: normal;
    font-weight: normal;
    text-transform: none;
    margin: 12px 0 8px 0;
  }
`;
export const AltTimesMessage = styled.div`
  padding: 10px 25px;
  line-height: 1.5em;
  font-family: 'Montserrat',sans-serif;
  font-size: 14px;
  font-style: italic;
`;
export const TimeFilter = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: none;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
`;
export const TimeFilterLabel = styled.div`
  color: #777;
  padding: 5px 0;
  text-align: center;
  font-family: 'Montserrat',sans-serif;
  font-size: 13px;
`;
export const TimeFilterSide = styled.div`
  width: 50%;
  padding: 0 2px;

  &.am {
    border-right: 1px solid #fff;
  }
  &.pm {
    border-left: 1px solid #fff;
  }
`;
export const TimeRow = styled.div`
  display: flex;
  margin-bottom: 10px;
  width:calc(100% - 15px);
`;
export const Time = styled.div`
  width: 20%;
  font-weight: bold;
`;
export const Status = styled.div`
  width: 45%;
  color: #8bd0e4;
  text-transform: uppercase;
  font-weight: bold;
`;
export const Action = styled.div`
  width: 35%;
`;
export const Button = styled.button`
  background-color: #fff;
  color: #083861;
  font-family: 'Montserrat',sans-serif;
  font-weight: 700;
  border-radius: 0;
  font-size: 16px;
  border: 0;
  line-height: 30px;
  padding: 0 12px;
  transition: background-color .4s ease-in-out;
  cursor: pointer;
  display: inline-block;
  box-sizing: border-box;
  text-transform: uppercase;
  position: relative;

  &.avail::before {
    content:"\f00c";
    font-family: "Font Awesome 5 Free";
    font-style: normal;
    margin-right: 5px;
  }
  &.name {
    font-size: 15px;

    i {
      position: absolute;
      left: 10px;
      top: 7px;
    }
  }
  &.disabled {
    color: #999;
    cursor: not-allowed;
    background: #ccc;
  }
`;

export const BannedCheck = styled.span`
  display: inline-block;

  i {
    position: absolute;
  }
`;
